module.exports = __webpack_public_path__ + "fonts/glyphicons-halflings-regular.448c34a5.woff2";